import { get, post } from "../common/dataFetch";
import { FavoriteEntry } from "../store/favorite";
import { WebControllers } from "../constants/webControllers";
import { WebActionNames } from "../constants/webActionNames";

export const createAsync = (favoriteEntry: Omit<FavoriteEntry, 'favoriteId'>) => post<number, Omit<FavoriteEntry, 'favoriteId'>>(WebControllers.Favorite, WebActionNames.CreateAsync, favoriteEntry);

export const readCollectionAsync = (userId: string) => get<FavoriteEntry[]>(WebControllers.Favorite, WebActionNames.Favorites, { userId });

export const deleteAsync = (favoriteEntry: Pick<FavoriteEntry, 'favoriteId'>) => post<number, Pick<FavoriteEntry, 'favoriteId'>>(WebControllers.Favorite, WebActionNames.DeleteAsync, favoriteEntry);